import { useState, useEffect } from 'react';
import {
  Button,
  Frame,
  SageClassnames,
  Choice,
  useSageBreakpoint,
} from '@kajabi/sage-react';
import { withOptimizely, WithOptimizelyProps } from '@optimizely/react-sdk';

import {
  PRODUCT_PLANS_OPTIONS,
  OPTIMIZELY_CONSTANTS,
  RUDDERSTACK_CONSTANTS,
  rudderstackTrackEvent,
} from '../../../utils/constants';

import { StepLayout } from './StepLayout';

interface PropsType extends WithOptimizelyProps {
  onStepChange: () => void;
  contentTab: string;
  handleOnChange: ({
    target: { id, value },
  }: {
    target: { id: string; value: string };
  }) => void;
  optimizely: any;
}

const UnwrappedProductPlansSlide = ({
  handleOnChange,
  onStepChange,
  optimizely,
}: PropsType) => {
  const [planToSell, setPlanToSell] = useState<string | null>(null);
  const breakpoints = useSageBreakpoint();

  useEffect(() => {
    rudderstackTrackEvent(
      RUDDERSTACK_CONSTANTS.productPlansSlideName,
      RUDDERSTACK_CONSTANTS.slideViewed,
      optimizely?.user?.id
    );
  }, []);

  const handleOnComplete = () => {
    optimizely.track(OPTIMIZELY_CONSTANTS.planToSellCompleted);
    rudderstackTrackEvent(
      RUDDERSTACK_CONSTANTS.productPlansSlideName,
      RUDDERSTACK_CONSTANTS.buttonClicked,
      optimizely?.user?.id
    );
    onStepChange();
  };

  return (
    <StepLayout
      backgroundColor="#FFFFFF"
      imageUrl="https://kajabi-app-assets.kajabi-cdn.com/ai-lead-gen/StevenJ.png"
    >
      <Frame gap={Frame.GAPS[breakpoints.md ? 'MD' : 'LG']}>
        <Frame gap={Frame.GAPS.XS}>
          <h2 className={SageClassnames.TYPE.HEADING_2}>
            What product do you want to launch and sell?
          </h2>
          <h6 className={SageClassnames.TYPE.HEADING_6}>
            Select one to get started. We will generate a product based on your
            selection. Don’t worry - you can create more later!
          </h6>
        </Frame>
        <Frame gap={Frame.GAPS.SM}>
          {PRODUCT_PLANS_OPTIONS.map((option) => (
            <Choice
              key={option.value}
              isActive={option.value === planToSell}
              text={option.label}
              style={{ width: '100%' }}
              radioConfigs={{
                id: option.value,
                value: option.value,
                onChange: () => {
                  handleOnChange({
                    target: {
                      id: 'plan_to_sell',
                      value: option.value,
                    },
                  });
                  setPlanToSell(option.value);
                },
              }}
            />
          ))}
        </Frame>
        <Frame
          align={Frame.ALIGNMENTS.BASELINE_RIGHT}
          direction={Frame.DIRECTIONS.HORIZONTAL}
        >
          <Button
            disabled={!planToSell}
            fullWidth={breakpoints.md}
            onClick={handleOnComplete}
          >
            Continue
          </Button>
        </Frame>
      </Frame>
    </StepLayout>
  );
};

export const ProductPlansSlide = withOptimizely(UnwrappedProductPlansSlide);
